import { AnimatePresence, motion } from 'framer-motion';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import { Advt } from './components/Advt/Advt';
import Message from './components/Message/Message';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';
import logo from './assets/images/logo.png';

function App() {
  const { currentState, currentMessage, stateCarousel } = useBroadcast();
  const { bgVideo, bgPoster, duration } = useGetParams();

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className="motionBlock"
            key={`advt-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Advt />
          </motion.div>
        )}
        {currentState === stateCarousel && currentMessage && (
          <motion.div
            className="motionBlock"
            key={`msg-${currentState}`}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Message
              currentMessage={currentMessage}
              message={currentMessage.message}
              duration={duration}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          playsInline
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          id="bgVideo"
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}

      <div id="img-loader">
        <img src={logo} alt="" />
      </div>
    </div>
  );
}

export default App;
